const itemData = [
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-design-v2.jpg',
        title:'Design'
    },
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-development-v2.jpg',
        title:'Development'
    },
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-marketing-v2.jpg',
        title:'Marketing'
    },
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-it-and-software-v2.jpg',
        title:'IT and Software'
    },
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-it-and-software-v2.jpg',
        title:'Personal Development'
    },
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-personal-development-v2.jpg',
        title:'Business'
    },
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-business-v2.jpg',
        title:'Photography'
    },
    {
        id:new Date().getTime().toString(),
        img:'https://s.udemycdn.com/home/top-categories/lohp-category-photography-v2.jpg',
        title:'Music'
    },
];


export default itemData